export default "__VITE_ASSET__Cd00XKhw__"